<template>
  <ul class="context-menu context-menu--desktop-fixed">
    <li
      v-for="(item, i) in items"
      :key="i"
      :class="'context-menu__item ' + (item.active ? ' context-menu__item--active' : '')"
    >
      <a :href="item.url" class="context-menu__item__a" @click="clickOnItem">{{ item.title }}</a>
    </li>
  </ul>
</template>

<script>
export default {
  name: "M4ContextMenu",
  props: {
    items: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  methods: {
    clickOnItem() {
      // for EPOS on the GO - public view of poster
      window.clickOnContextMenuItem = true;
    }
  }
};
</script>
